var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "multiselect",
    _vm._b(
      {
        attrs: {
          options: _vm.options,
          multiple: true,
          searchable: true,
          loading: _vm.internalIsLoading,
          "close-on-select": false,
          "clear-on-select": false,
          "preserve-search": true,
          placeholder: _vm.placeholder,
          "track-by": "value",
          label: "label",
        },
        on: {
          input: _vm.updateValue,
          "search-change": _vm.handleSearch,
          close: _vm.handleClose,
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function ({ values, search, isOpen }) {
              return [
                values.length && !isOpen
                  ? _c("span", { staticClass: "multiselect__single" }, [
                      _vm._v(
                        " " + _vm._s(values.length) + " options selected "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      },
      "multiselect",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }